import isMobile from "./isMobile";

const $ = jQuery.noConflict();

export default function mobileFooterNavInit() {
    if (isMobile()) {
        const slideDuration = 300;

        $(".footer-menu__title").click(function onClick(eventObject) {
            eventObject.preventDefault();
            $(this)
                .parents(".footer-menu")
                .find(".footer-menu__items")
                .slideToggle(slideDuration);
        });
    }
}
